import React, { Component } from 'react'
// eslint-disable-next-line
import { Link, Navigate, Route, Routes } from 'react-router-dom'
import DataTable from 'react-data-table-component';
import { connect } from "react-redux"
import { increment, decrement } from "../features/counter/counterSlice"
import { setLoggedIn } from "../features/account/loginSlice"
import { setAccount } from "../features/account/accountSlice"
import { setCompany } from "../features/account/companySlice"
import axios from "axios";
import qs from 'qs';
import Swal from 'sweetalert2'
import { hidePreloader, showPreloader, priceFormat } from '../library/helper';
import { withTranslation } from 'react-i18next';

export class Removal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumn: [],
            tableData: [],
            tableFiltered: [],
            tableFilter: "",
            tableResetPagination: false,
            revenueUnit: "",
            isDummy: false,
        }
    }

    isFreemiumUser = () => {
        const a = this.props.account || {};
        return (
            a.client_subscription === 1
        );
    };

    makeDummyRows = () => {
        const today = new Date();
        return Array.from({ length: 5 }, (_, i) => {
            const d = new Date(today);
            d.setMonth(d.getMonth() - i);
            const iso = d.toISOString().slice(0, 10);
            return {
                removal_uuid: `dummy-${i + 1}`,
                record_date: iso,
                removal_name: `Biochar Project ${i + 1}`,
                removal_amount: 300 + i * 10, // tCO2e
            };
        });
    };

    componentDidMount = async () => {
        showPreloader();

        const data = {};
        let tempRevenueUnit = "";

        try {
            const optionsSetting = {
                withCredentials: true,
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: `${process.env.REACT_APP_BASE_SERVER}/account/setting/read`
            };
            const responseSetting = await axios(optionsSetting);
            if (responseSetting.data.success) {
                if (responseSetting.data?.data?.[0]?.client_revenue_unit == 1) {
                    tempRevenueUnit = "IDR mn";
                } else {
                    tempRevenueUnit = "USD k";
                }
            }
        } catch (e) {
            // ignore; keep default
        }

        let record = [];
        try {
            const options = {
                withCredentials: true,
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: `${process.env.REACT_APP_BASE_SERVER}/removal/get_all`
            };
            const response = await axios(options);
            if (response.data.success) {
                record = response.data.data || [];
            }
        } catch (e) {
            record = [];
        }

        let useDummy = false;
        if (this.isFreemiumUser() && record.length === 0) {
            record = this.makeDummyRows();
            useDummy = true;
        }

        const columns = [
            {
                name: this.props.t('emission.table.label1'),
                selector: row => row.record_date,
                sortable: true,
                filterable: true,
            },
            {
                name: this.props.t('removal.table.label1'),
                selector: row => row.removal_name,
                sortable: true,
                filterable: true,
            },
            {
                name: this.props.t('emission.table.label5'),
                selector: row => `${priceFormat(row.removal_amount.toFixed(2))} tCO\u2082e`,
                sortable: true,
                filterable: true,
            },
            {
                name: this.props.t('emission.table.label6'),
                selector: row => {
                    const isDemo = String(row.removal_uuid).startsWith('dummy-');
                    return (
                        <div className="d-flex flex-wrap gap-2">
                            <Link
                                to={isDemo ? '#' : ('/removal/update/' + row.removal_uuid)}
                                className={`btn btn-info ${isDemo ? 'disabled' : ''}`}
                                onClick={e => { if (isDemo) e.preventDefault(); }}
                                title={isDemo ? 'Demo row' : undefined}
                            >
                                {this.props.t('general.btnUpdate')}
                            </Link>
                            <button
                                onClick={() => this.onDelete(row.removal_uuid)}
                                className="btn btn-warning"
                                disabled={isDemo}
                                title={isDemo ? 'Demo row' : undefined}
                            >
                                {this.props.t('general.btnDelete')}
                            </button>
                        </div>
                    )
                },
                sortable: true,
                filterable: true,
                width: "210px",
            },
        ];

        this.setState({
            tableColumn: columns,
            tableData: record,
            tableFiltered: record,
            revenueUnit: tempRevenueUnit,
            isDummy: useDummy,
        });

        hidePreloader();
    }

    onFilter = async (e) => {
        const val = e.target.value || "";
        const baseData = this.state.tableData;
        if (val.trim() !== "") {
            const filteredData = baseData.filter(
                item => (item.removal_name || "").toLowerCase().includes(val.toLowerCase())
            );
            this.setState({
                tableFilter: val,
                tableFiltered: filteredData,
            });
        } else {
            this.setState({
                tableFilter: "",
                tableFiltered: baseData,
            });
        }
    }

    onClear = async () => {
        if (this.state.tableFilter !== "") {
            this.setState({
                tableFilter: "",
                tableFiltered: this.state.tableData,
            });
        }
    }

    onDeleteCall = async (data) => {
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: `${process.env.REACT_APP_BASE_SERVER}/removal/delete`
        };
        const response = await axios(options);
        return !!response.data.success;
    }

    onDelete = async (id) => {
        if (String(id).startsWith('dummy-')) return; // ignore demo rows

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const ok = await this.onDeleteCall({ id });
                if (!ok) {
                    Swal.fire({
                        title: '',
                        html: '<p>Cannot delete data, please try again later</p>',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    })
                } else {
                    Swal.fire({
                        title: 'Deleted',
                        text: "Your data has been deleted.",
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    }).then((r) => {
                        if (r.isConfirmed) window.location.reload();
                    })
                }
            }
        })
    }

    render() {
        const { tableColumn, tableFilter, tableFiltered, isDummy } = this.state;
        const paginationComponentOptions = {
            rowsPerPageText: this.props.t('table.paginationResult'),
            rangeSeparatorText: this.props.t('table.paginationResultPage'),
        };

        return (
            <div className="page-content">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">{this.props.t("menu.label32")}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-0">{this.props.t('general.read')}</h5>
                                    <br /><br />
                                    <Link to={'/removal/create'} className="btn btn-success">{this.props.t('general.btnCreate')}</Link>
                                    <div className="col-lg-4" style={{ float: "right" }}>
                                        <div className="input-group">
                                            <span className="input-group-text" id="search"><i className="ri-search-line"></i></span>
                                            <input
                                                value={tableFilter}
                                                onChange={e => this.onFilter(e)}
                                                type="text"
                                                className="form-control"
                                                placeholder={this.props.t('table.search')}
                                                aria-describedby="search"
                                            />
                                        </div >
                                    </div >
                                </div >
                                <div className="card-body" style={{ position: 'relative' }}>
                                    {isDummy && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                textAlign: "center",
                                                fontSize: "3rem",
                                                fontWeight: "bold",
                                                color: "rgba(0,0,0,0.2)",
                                                pointerEvents: "none",
                                                userSelect: "none",
                                                zIndex: 3
                                            }}
                                        >
                                            {this.props.t("menu.callToUpgrade2")}
                                        </div>
                                    )}
                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <DataTable
                                            columns={tableColumn}
                                            data={tableFiltered}
                                            noDataComponent={this.props.t('table.empty')}
                                            pagination
                                            paginationComponentOptions={paginationComponentOptions}
                                        />
                                    </div>
                                </div>
                            </div >
                        </div >
                    </div >

                </div >
            </div >
        )
    }
}

const mapStateToProps = (state) => ({
    count: state.counter.value,
    loggedIn: state.loggedIn.value,
    account: state.account.value,
    company: state.company.value,
});

const mapDispatchToProps = { increment, decrement, setLoggedIn, setAccount, setCompany };

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Removal));
